import { API } from 'aws-amplify';
import { SHA256 } from 'crypto-js';
import { getCurrentUserEmail } from '../utils/auth/authenticatedUser';

const source = 'smartconsent-app';

const runIntegration = async (integration, requestId, clientId, data) => {
  const userEmail = await getCurrentUserEmail();
  const user = SHA256(userEmail).toString();
  const body = {
    ...data,
    integration,
    requestId,
    clientId,
    user,
    source,
  };
  return API
    .post('RunIntegration', '/', { body });
};

export const runFinicity = (requestId, clientId, data) => (runIntegration('finicity', requestId, clientId, data));
export const runFlinks = (requestId, clientId, data) => (runIntegration('flinks', requestId, clientId, data));
export const runInverite = (requestId, clientId, data) => (runIntegration('inverite', requestId, clientId, data));
export const runPinwheel = (requestId, clientId, data) => (runIntegration('pinwheel', requestId, clientId, data));
export const runPlaid = (requestId, clientId, data) => (runIntegration('plaid', requestId, clientId, data));
export const runSymcor = (requestId, clientId, data) => (runIntegration('symcor', requestId, clientId, data));
